import PubSub from "pubsub-js";

export enum PUBSUB_KEYS {
  FINANCE_URL = "finance_url",
}

export type inferE<T> = { type: number; url: string; message: string; name: string }; //

export type InferPublish = <T extends PUBSUB_KEYS>(key: T, data: inferE<T>) => void;
export type InferSubscribe = <T extends PUBSUB_KEYS>(key: T, callback: (data: inferE<T>) => void, params?: { isOne?: boolean }) => void;

export const publish: InferPublish = (key, data) => {
  PubSub.publish(key, data);
};

export const subscribe: InferSubscribe = (key, callback, params) => {
  const { isOne = false } = params || {};
  PubSub[isOne ? "subscribeOnce" : "subscribe"](key, (_, data) => {
    callback(data);
  });
};
export const unsubscribe = (key: PUBSUB_KEYS) => {
  PubSub.unsubscribe(key);
};
